import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IFormModalProps } from '../../../models/forms/IForm';
import { IImportTray } from '../../../models/forms/IImportTray';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import ImportTrayDetailsForm from '../forms/import-tray-details-form';

const ImportTrayDetails = (props: IFormModalProps) => {
  const initialValues: IImportTray = { csvFile: null };
  const { trayManagementStore } = useStore();
  const {
    trayFileUploadService,
    fileUploadState,
    resetFileUploadState,
    duplicateData,
  } = trayManagementStore;

  useEffect(() => {
    if (fileUploadState.success) {
      onModalClosed();
    }
  }, [fileUploadState.success]);

  useEffect(() => {
    if (fileUploadState.error) {
      toast.error(formatMessage(fileUploadState.error));
      resetFileUploadState();
    }
  }, [fileUploadState.error]);

  const onSubmitForm = (values: IImportTray) => {
    trayFileUploadService(
      Number(getTenantIdFromLocalStorage()),
      values.csvFile
    );
  };

  const onModalClosed = () => {
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className="correction-modal fancy-modal"
        addHeader="import_tray"
        updateHeader="import_tray"
        onModalClosed={onModalClosed}
        isLoading={fileUploadState.inProgress}
      >
        <ImportTrayDetailsForm
          initialValues={initialValues}
          id={props.id}
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={fileUploadState.inProgress}
          duplicateData={duplicateData}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(ImportTrayDetails);
